import styled from "styled-components";

export const MobileAppStyled = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const MobileContentStyled = styled.div`
    position: relative;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    
    &.mobile-platform {
        overflow: hidden;
        padding: 32px 16px 16px;

        &.with-menu {
            padding-bottom: 70px;
        }

        &.fade-in {
            opacity: 0;
            animation: aniblock 1s forwards;

            @keyframes aniblock {
                from {
                    opacity: 0;
                }
                to {
                    opacity: 1;
                }
            }
        }
    }
`;
